var _path, _circle, _path2, _circle2, _circle3, _circle4, _circle5, _path3, _path4, _circle6, _path5, _circle7, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _circle8, _path16, _path17, _path18, _path19, _path20, _path21;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrggoals(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 793.563,
    height: 662.464,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M0 321.247 542.134 0l16.305 27.515L16.305 348.762zM117.831 348.18 659.965 26.933l16.305 27.515-542.134 321.247zM222.197 377.638 764.33 56.391l16.304 27.515L238.5 405.153z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 353.12,
    cy: 206.844,
    r: 169.736,
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M182.122 206.844c0-94.289 76.71-170.999 170.998-170.999s170.999 76.71 170.999 170.999-76.71 170.998-170.999 170.998-170.998-76.71-170.998-170.998Zm2.525 0c0 92.896 75.577 168.473 168.473 168.473s168.474-75.577 168.474-168.473S446.017 38.37 353.12 38.37s-168.473 75.577-168.473 168.474Z",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M526.082 326.35a30.257 30.257 0 1 1 30.257 30.257 30.257 30.257 0 0 1-30.257-30.257Zm30.257-28.782a28.814 28.814 0 0 0-28.781 28.782 28.781 28.781 0 1 0 28.78-28.782Z",
    transform: "translate(-203.219 -118.768)",
    fill: "#3f3d56",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M498.776 326.35a57.563 57.563 0 1 1 57.563 57.562 57.563 57.563 0 0 1-57.563-57.562Zm57.563-56.087a56.087 56.087 0 1 0 56.087 56.087 56.15 56.15 0 0 0-56.087-56.087Z",
    transform: "translate(-203.219 -118.768)",
    fill: "#ccc",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.166 326.35a112.173 112.173 0 1 1 112.173 112.173A112.3 112.3 0 0 1 444.166 326.35Zm112.173-110.697A110.697 110.697 0 1 0 667.036 326.35 110.823 110.823 0 0 0 556.34 215.653Z",
    transform: "translate(-203.219 -118.768)",
    fill: "#ccc",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 353.12,
    cy: 206.844,
    r: 14.022,
    fill: "#65ac67",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 316.959,
    cy: 247.433,
    r: 14.022,
    fill: "#65ac67",
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 458.035,
    cy: 241.529,
    r: 14.022,
    fill: "#65ac67",
    style: {
      isolation: "isolate"
    }
  }), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 353.12,
    cy: 206.844,
    r: 6.642,
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 458.035,
    cy: 241.529,
    r: 6.642,
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 316.959,
    cy: 248.171,
    r: 6.642,
    fill: "#2f2e41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 43.168,
    cy: 132.308,
    r: 6.642,
    fill: "#65ac67"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "M352.751 132.677H61.248v-1.476h292.98v76.011h-1.477v-74.535z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.98 132.308a19.188 19.188 0 1 1 19.188 19.187 19.188 19.188 0 0 1-19.188-19.188Zm19.188-17.712a17.712 17.712 0 1 0 17.712 17.711 17.732 17.732 0 0 0-17.712-17.711Z",
    fill: "#2f2e41"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 87.447,
    cy: 323.445,
    r: 6.642,
    fill: "#65ac67"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M68.26 323.445a19.188 19.188 0 1 1 19.187 19.187 19.188 19.188 0 0 1-19.188-19.187Zm19.187-17.712a17.712 17.712 0 1 0 17.711 17.712 17.732 17.732 0 0 0-17.711-17.712Z",
    fill: "#2f2e41"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 663.932,
    cy: 163.303,
    r: 6.642,
    fill: "#65ac67"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M644.745 163.303a19.188 19.188 0 1 1 19.187 19.187 19.188 19.188 0 0 1-19.187-19.187Zm19.187-17.712a17.732 17.732 0 0 0-17.711 17.712 17.712 17.712 0 1 0 17.711-17.712Z",
    fill: "#2f2e41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "m457.297 165.528 188.174-2.963.023 1.475-186.721 2.941v74.548h-1.476v-76.001zM105.897 322.707h210.324v-74.536h1.476v76.011h-211.8v-1.475z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M2.579 166.993h81.178v5.166H2.579zM2.579 181.752h81.178v5.166H2.579zM2.579 196.512h81.178v5.166H2.579zM46.858 358.13h81.178v5.166H46.858zM46.858 372.889h81.178v5.166H46.858zM46.858 387.649h81.178v5.166H46.858zM623.343 198.726h81.178v5.166h-81.178zM623.343 213.485h81.178v5.166h-81.178zM623.343 228.245h81.178v5.166h-81.178z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb8b8",
    d: "m743.166 638.861-11.544 4.126-21.408-42.566 17.039-6.089 15.913 44.529z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m712.885 662.303-.168-.47a15.405 15.405 0 0 1 9.311-19.668l22.736-8.126L750.11 649Z",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffb8b8",
    d: "m668.095 650.28-12.26-.001-5.832-47.288 18.094.001-.002 47.288z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m671.221 662.164-39.53-.002v-.5a15.386 15.386 0 0 1 15.386-15.386h.001l24.144.001Z",
    fill: "#2f2e41"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m696.035 348.17-5.332-10.535s-19.862 4.976-21.668 16.488Z",
    fill: "#65ac67"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#2f2e41",
    d: "m718.035 468.635-14.5 80.913 38.5 68.087-23 9-39-66-5-18-3 94-20.743-.63-9.511-87.773 15.254-81.597 61 2z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M648.781 483.232c-.45-2.004-1.74-63.173-1.74-63.173s21.325-70.01 21.52-70.584l.076-.225 16.191-6.07c.227-.104 5.621-2.507 10.036-.504a8.65 8.65 0 0 1 4.6 5.654c1.837 1.368 15.07 16.192 15.07 36.3l.5 47.45 11.095 51.44-.49.104c-.303.064-13.827 4.139-35.128 4.139-11.836 0-41.73-4.531-41.73-4.531Z",
    fill: "#3f3d56"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 674.143,
    cy: 312.435,
    r: 21.883,
    fill: "#ffb8b8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m705.318 408.841-38.283 53.416-5.654-24.945 43.937-28.471z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M637.371 463.409a9.39 9.39 0 0 0 8.8-11.398l28.446-17.45-15.708-7.348-24.605 17.697a9.442 9.442 0 0 0 3.067 18.499Z",
    fill: "#ffb8b8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#65ac67",
    d: "m657.035 427.635-9.743 6.827 8.263 14.673 11.48-9.5-10-12z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m651.934 428.065 22.917-26.563-8.78-36.639a16.031 16.031 0 0 1 29.705-11.336l.2.371 8.09 54.409-40.654 41.67Z",
    fill: "#3f3d56"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m692.782 331.434-18.163.652c-1.107.04-4.112-11.909-4.505-14.387a6.765 6.765 0 0 0-7.057-5.473c-1.36.129-4.788-2.411-8.326-5.42-6.716-5.71-6.367-16.434 1.011-21.26q.303-.197.594-.36c4.655-2.606 10.1-3.48 15.433-3.547 4.835-.06 9.807.548 14.067 2.836 7.637 4.103 11.7 13.07 12.058 21.73s-2.42 17.132-5.571 25.208",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M792.563 662.464h-221a1 1 0 0 1 0-2h221a1 1 0 0 1 0 2Z",
    fill: "#3f3d56"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrggoals);
export default __webpack_public_path__ + "static/media/orggoals.fb3a94edcd6a64945c8987419a78fd12.svg";
export { ForwardRef as ReactComponent };